module.exports = __webpack_public_path__ + "static/img/chB_1.dfb7150.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/chB_1.png
// module id = 1273
// module chunks = 1